/**
 * StatusChip.jsx - 2026-10-13: the status of a number: SOURCED (green), DERIVED (blue), EDUCATED_GUESS (orange), NO_DATA (grey).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';

const COLORS = { SOURCED: 'success', DERIVED: 'info', EDUCATED_GUESS: 'warning', NO_DATA: 'default' };

const StatusChip = ({ status }) => {
  const { t } = useTranslation();
  if (!COLORS[status]) throw new Error(`StatusChip: unknown status '${status}' (valid: ${Object.keys(COLORS).join(', ')})`);
  return <Chip size="small" variant="outlined" color={COLORS[status]} label={t(`tab2.status.${status}`)} sx={{ flexShrink: 0 }} />;
};

export default StatusChip;
